import React from 'react';
import { omit } from 'lodash';
import { Field } from 'redux-form';
import { compose, withState, withHandlers } from 'recompose';

import { Button } from 'components/Form';

const Component = compose(
  withState('value', 'updateValue', ''),
  withHandlers({
    onChange: (props: any) => e => (
      toBase64(e.target.files).then(value => {
        props.updateValue(value);
        props.input.onChange(value);
      })
    )
  }),
)(({
  onChange,
  imageName,
  imageSrc,
  input,
  value,
}: any) =>
  <div className="b-image-input">
    <label className="b-image-input__label">
      <Button>Select file</Button>
      <input
        type="file"
        className="b-image-input__native"
        onChange={onChange}
      />
      {imageName && (
        <div className="b-image-input__name">
          {imageName}
        </div>
      )}
    </label>
    {(value || imageSrc) && (
      <img
        className="b-image-input__image"
        src={value || imageSrc}
      />
    )}
    <input
      type="hidden"
      {...input}
      value={value || imageSrc}
    />
  </div>
);

function toBase64(files) {
  return new Promise((resolve, reject) => {
    const file = files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.addEventListener('load', () => {
      resolve(reader.result);
    }, false);
  });
}

export const ImageInput = (props) => (
  <Field
    component={Component}
    {...props}
  />
)

export type IImageInputOnUpload = (files: any[]) => void;

export type IImageInputProps = {
  onUpload: IImageInputOnUpload,
  imageSrc?: string,
  imageName?: string,
}
